class SearchModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    if (!this.detailsContainer || !this.summaryToggle) return; // ← prevents crash

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code?.toUpperCase() === 'ESCAPE' && this.close()
    );

    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));

    const closeBtn = this.querySelector('button[type="button"]');
    const resetBtn = this.querySelector('button[type="reset"]');

    closeBtn?.addEventListener('click', this.close.bind(this));
    resetBtn?.addEventListener('click', this.reset.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  onSummaryClick(event) {
    event.preventDefault();
    this.detailsContainer.hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) && !event.target.classList.contains('modal-overlay')) {
      this.close();
    }
  }

  open() {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.detailsContainer.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('search-modal--open');
    trapFocus(this.detailsContainer.querySelector('[tabindex="-1"]'), this.querySelector('input:not([type="hidden"])'));
  }

  close() {
    removeTrapFocus();
    this.detailsContainer.removeAttribute('open');
    if (this.onBodyClickEvent) {
      document.body.removeEventListener('click', this.onBodyClickEvent);
    }
    document.body.classList.remove('search-modal--open');
    document.dispatchEvent(new CustomEvent('searchmodal:close'));
  }

  reset(event) {
    event.preventDefault();
    const input = this.querySelector('input[type="search"]');
    if (input) input.value = '';
  }
}

if (typeof customElements !== 'undefined') {
  customElements.define('search-modal', SearchModal);
}